import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk  from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import reducer from './reducers/index.js';

const configureStore = (history) => {
  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  if (process.env.NODE_ENV === 'production') {
    return createStore(connectRouter(history)(reducer), compose(applyMiddleware(...middleware)));
  }
  return createStore(connectRouter(history)(reducer), compose(composeWithDevTools(applyMiddleware(...middleware))));
};

export default configureStore;




// WEBPACK FOOTER //
// ./src/client/configurestore.js